import request from "@/utils/request";
// 解保列表
export const lists = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/jiebao/lists",
  });
};
// 申请解保
export const applys = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/jiebao/apply",
  });
};
// 申请解保列表 审批
export const shenpi = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/jiebao/shenpi",
  });
};
// 申请续保保列表
export const xubaolists = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/xubao/lists",
  });
};
// 申请续保
export const apply = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/xubao/apply",
  });
};
// 申请续保保列表 审批
export const shenpis = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/xubao/shenpi",
  });
};
// 贷后管理--> 获取工程列表
export const gclist = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/daihou/gclist",
  });
};
// 贷后管理--> 获取工程列表详情
export const gcdetail = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/daihou/gcdetail",
  });
};
// 贷后管理-->  获取进度
export const gcjindu = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/daihou/gcjindu",
  });
};
// 贷后管理-->  获取进度详情
export const jindu_detail = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/daihou/jindu_detail",
  });
};
// 贷后管理-->  添加添加工程项目进度
export const addpro = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/daihou/addpro",
  });
};
// 贷后管理-->  弃保-- 列表
export const qibaoLists = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/qibao/lists",
  });
};
// 贷后管理-->  弃保--申请
export const sapply = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/qibao/apply",
  });
};
// 贷后管理-->  弃保-- 审批
export const qibaoShenpi = (e) => {
  console.log(e);
  return request({
    method: "POST",
    data: { ...e },
    url: "/handle/qibao/shenpi",
  });
};



// WEBPACK FOOTER //
// ./src/api/daihou.js